export enum ViewabilityEventConditions {
  OnScreen = 'onScreen',
  On50PercentVisible = 'on50PercentVisible',
  On100PercentVisible = 'on100PercentVisible',
  OnNotVisible = 'onNotVisible'
}
